import React from 'react';
import styled from 'styled-components';

const Row: any = styled.div`
  box-sizing: border-box;
  display: flex;
  flex: 0 1 auto;
  flex-direction: row;
  flex-wrap: wrap;
  margin-left: ${(props) => props.theme.grid.negGutterWidth};
  margin-right: ${(props) => props.theme.grid.negGutterWidth};

  @media (max-width: 960px) {
    flex-direction: column;
  }
`;

//When displayed in a Modal, the negative margins on the row component above result in unnecessary scroll bars, so this
//is to provide an easy way to get the same component without those margins.
export const ModalRow = styled.div`
  box-sizing: border-box;
  display: flex;
  flex: 0 1 auto;
  flex-direction: row;
  flex-wrap: wrap;

  @media (max-width: 960px) {
    flex-direction: column;
  }
`;

export default Row;
